module.exports = __webpack_public_path__ + "media/registry_2000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry_2000.jpg
// module id = 34
// module chunks = 0